export enum TipoPrecoEnum {
    Promocional = "1",
    Padrao = "2"
}